import Vue from 'vue';

// Login
import LoginPage from './components/loginPage';
import signInWithGoogle from './components/signInWithGoogle';
import maintenance from './components/siteDown';

import switchClient from './components/switchClient';

// magicLink for mobile app login and get access token with token-link
import magicLink from './components/magicLink';

// Reset Password
import resetPassword from './components/resetPassword';
// Public worker onboarding form (PWA target for SMS / QR onboarding)
import onboardForm from './components/onboardForm';
import wishlistConfirm from './components/wishlistConfirm';
// #1533: wishlist-summary assign page (opened from the report's per-row link)
import WishlistAssign from './components/wishlist/WishlistAssign';
// Page not found
import pageNotFound from './components/pageNotFound';
// Jobs List
import JobList from './components/jobs/jobList';
// Jobs Details
import jobDetails from './components/jobs/jobDetails';
// review deleted jobs
import reviewDeletedJob from './components/jobs/reviewDeletedJob';
// Resume
import Resume from './components/resume/resume';
// Calls List (lazy — wijmo is ~8MB)
const CallList = () => import(/* webpackChunkName: "grapecity" */ './components/calls/callList');
// #1697 Payroll FlexSheet (lazy — shares the wijmo "grapecity" chunk, #1464 lesson)
const PayrollSheet = () => import(/* webpackChunkName: "grapecity" */ './components/payroll/payrollSheet');
// #1744 Payroll template workspace (SA). MOVED into "grapecity" — the note that
// used to sit here said to do exactly this "when a Wijmo designer lands in the
// editing seam", and it now has: the placeholder textarea was replaced by a real
// FlexSheet with a formatting toolbar, formula bar and cell locking. The page
// therefore pulls wijmo.grid.sheet + wijmo.xlsx + jszip and MUST share the lazy
// wijmo chunk rather than duplicate it — and must never reach the core bundle
// (#1464).
const PayrollTemplateWorkspace = () => import(/* webpackChunkName: "grapecity" */ './components/payroll/payrollTemplateWorkspace');
// #1763 payroll workbook — a job's data inside the real template (shares the wijmo chunk)
const PayrollJobWorkbook = () => import(/* webpackChunkName: "grapecity" */ './components/payroll/payrollJobWorkbook');
// Employees
import EmployeeList from './components/employees/employeeList';
import EmployeeDetails from './components/employees/employeeDetails';
import addEmployeePersonal from './components/employees/addEmployeePersonal';
import addEmployee from './components/employees/addEmployee';
import editEmployee from './components/employees/editEmployee';
import deleteEmployee from './components/employees/deleteEmployee';
import vacationLog from './components/employees/vacationLog';
import addEmployeeNewFlow from './components/employees/addEmployeeNewFlow';
import clientEmployeeAssociation from './components/employees/clientEmployeeAssociation';

// Emplyers
import EmployerList from './components/employers/employerList';
import addEmployer from './components/employers/addEmployer';
import editEmployer from './components/employers/editEmployer';
import deleteEmployers from './components/employers/deleteEmployers';
import employerDetails from './components/employers/employerDetails';
// Skills
import Skills from './components/skills/viewSkills';
import archiveSkills from './components/skills/archiveSkills';
import rateTable from './components/skills/rateTable';
// Notify
import Notify from './components/notify';

import CsInvoices from './components/csInvoices';
import SplashPage from './components/splashPage';
import PrivacyPolicyEditor from './components/privacyPolicyEditor';
import PrivacyPolicyReview from './components/privacyPolicyReview';
import Employee911Availability from './components/Employee911Availability';
// Daily Schedule
import DailySchedule from './components/dailySchedule';
// Phonesheet
import PhoneSheet from './components/phoneSheet';
// Files
import Files from './components/files';

// Drive
import Drive from './components/drive/DriveIndex';

// Calls
// import bulkAssign from './components/calls/bulkAssign';
// import bulkAssignCustom from './components/calls/bulkAssignCustom';
import bulkAssignCustom from './components/calls/assign/bulk';

// import singleAssign from './components/calls/singleAssign';
// import singleAssignCustom from './components/calls/singleAssignCustom';
import singleAssignCustom from './components/calls/assign/single';
// View Calls
import ViewCalls from './components/calls/viewCalls';
import addCall from './components/calls/addCall';

const jobAttendance = () => import(/* webpackChunkName: "grapecity" */ './components/calls/jobAttendance');
// Schedule
import Schedule from './components/schedule/schedule';
import scheduleWishlist from './components/schedule/wishlist';
import scheduleSmslog from './components/schedule/smslog';

import clientSMSLog from './components/clientSmsLog';
import actionLog from './components/schedule/actionlog';
//Sign in Sheet
import signinsheet from './components/schedule/signinsheet.vue';
import jobSheet from './components/jobs/signInSheet/clientSheet.vue';
// Profile
import myProfile from './components/userProfile/myProfile';
import stripeSuccess from './components/userProfile/stripeSuccess';

// authNylas
import authNylas from './components/userProfile/authNylas';

// Venue
import venueMain from './components/venue/venue';
import addVenue from './components/venue/addVenue';
// Report
import reportMain from './components/report/report';
import reportList from './components/report/reportList';
import newReportGlobal from './components/report/newRepotGlobal.vue';
import reportsAppSmith from './components/report/reportsAppSmith.vue';
import ReportsLanding from './components/report/ReportsLanding.vue';
import OnboardingProfiles from './components/onboarding/OnboardingProfiles.vue';
import SendOnboardingLink from './components/onboarding/SendOnboardingLink.vue';
// Lazy-loaded into the shared "grapecity" webpack chunk alongside
// callList, jobAttendance, and activeReports so all Wijmo-using
// components share one runtime init.
const MonthlyJobReport         = () => import(/* webpackChunkName: "grapecity" */ './components/report/MonthlyJobReport.vue');
const EmployeeExportReport     = () => import(/* webpackChunkName: "grapecity" */ './components/report/EmployeeExportReport.vue');
const EmployerExportReport     = () => import(/* webpackChunkName: "grapecity" */ './components/report/EmployerExportReport.vue');
const EmployerShiftCountReport = () => import(/* webpackChunkName: "grapecity" */ './components/report/EmployerShiftCountReport.vue');
const LastConfirmedShiftReport = () => import(/* webpackChunkName: "grapecity" */ './components/report/LastConfirmedShiftReport.vue');
const UserTotalHoursReport     = () => import(/* webpackChunkName: "grapecity" */ './components/report/UserTotalHoursReport.vue');
const ActionLogSearchReport    = () => import(/* webpackChunkName: "grapecity" */ './components/report/ActionLogSearchReport.vue');
const AttendanceReport         = () => import(/* webpackChunkName: "grapecity" */ './components/report/AttendanceReport.vue');
const CallUserSkillHoursReport = () => import(/* webpackChunkName: "grapecity" */ './components/report/CallUserSkillHoursReport.vue');
const FailedSmsReport          = () => import(/* webpackChunkName: "grapecity" */ './components/report/FailedSmsReport.vue');
const NlrbReport               = () => import(/* webpackChunkName: "grapecity" */ './components/report/NlrbReport.vue');
const NoticeLogSearchReport    = () => import(/* webpackChunkName: "grapecity" */ './components/report/NoticeLogSearchReport.vue');
const UnsubscribedEmailReport  = () => import(/* webpackChunkName: "grapecity" */ './components/report/UnsubscribedEmailReport.vue');
const MonthlyJobChartReport    = () => import(/* webpackChunkName: "grapecity" */ './components/report/MonthlyJobChartReport.vue');
const AttendanceChartReport    = () => import(/* webpackChunkName: "grapecity" */ './components/report/AttendanceChartReport.vue');
const activeReports = () => import(/* webpackChunkName: "grapecity" */ './components/report/activeReports');

// Configuration
import configurationMain from './components/configuration/configuration';
//calendar
import calendar from './components/calendar/calendar.vue';
import calendarJobCall from './components/calendar/calendarJobCall.vue';
// SUPER ADMIN
//client List
import clientList from './components/superAdmin/clientList.vue';
//add client
import addClient from './components/superAdmin/addClient.vue';
//edit client
import editClient from './components/superAdmin/editClient.vue';
//Send Notice
import clientSendNotice from './components/superAdmin/clientSendNotice.vue';
// Manage Exception
import manageExceptions from './components/superAdmin/manageExceptions.vue';
// Add Employee CSV
import addEmployeeCSV from './components/superAdmin/addEmployeeCSV.vue';

import adminConfig from './components/superAdmin/adminConfig.vue';

import ReportsConfig from './components/superAdmin/reportsConfig/ReportsConfig.vue';
import ConcurrencyEventsPanel from './components/superAdmin/trafficTrap/ConcurrencyEventsPanel.vue';
import CadenceFlagQueue from './components/superAdmin/trafficTrap/CadenceFlagQueue.vue';


//Employer from Super-Admin
import clientEmployersList from './components/superAdmin/employers/clientEmployersList.vue';
import addEmployerClient from './components/superAdmin/employers/addEmployerClient.vue';
import editEmployerClient from './components/superAdmin/employers/editEmployerClient.vue';
import employerDetailsClient from './components/superAdmin/employers/employerDetailsClient.vue';
import empoyerProfile from './components/employers/empoyerProfile';
import companyInfo from './components/employers/companyInfo';
import employerUserList from './components/employers/employerUserList';
import addEmployerUser from './components/employers/addEmployerUser';
import editEmployerUser from './components/employers/editEmployerUser';
import employerJobList from './components/jobs/employerJobList';
import employerJobDetails from './components/jobs/employerJobDetails';
import employerSignInSheet from './components/jobs/signInSheet/employerSignInSheet';
import viewCallsEmployer from './components/calls/employer/viewCalls';
import calendarEmployer from './components/calendar/calendarEmployer.vue';
import tinyUrl from './components/superAdmin/tinyUrl.vue';
import forceLogin from './components/forceLogin';

// Open Window — employee self-dispatch page (no auth required, token in URL)
const EmployeeWindow = () => import('./components/window/employeeWindow');

// super admin employee.
import superAdminEmployeeList from './components/superAdmin/employees/superAdminEmployeeList.vue';
import mergeEmployee from './components/superAdmin/employees/mergeEmployee.vue';

// Employee Merger Form
import employeeMergerForm from './components/superAdmin/mergers/employeeMergerForm.vue';

// Employer Merger Form
import employerMergerForm from './components/superAdmin/mergers/employerMergerForm.vue';



function cookie() {
    var cookie = document.cookie.split("=");
    return cookie[1];
}
export const superAdminRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    'jobReports',
    'wishlistAssign',
    'clientList',
    'addClient',
    'editClient',
    'clientSendNotice',
    'manageExceptions',
    'addEmployeeCSV',
    'clientEmployersList',
    'addEmployerClient',
    'editEmployerClient',
    'PayrollSheet',
    'PayrollJobWorkbook',
    // #1744 — a NEW SA route is exactly the shape that broke #1697 and #1481:
    // the control renders, then main.js's guard rejects the route NAME and
    // bounces to the role's default page. Registering the route is not enough;
    // the name has to be in THIS array. Verify by navigating as an SA, not by
    // reading the code.
    'PayrollTemplateWorkspace',
    'employerDetailsClient',
    'tinyUrl',
    'adminConfig',
    'ReportsConfig',
    'ConcurrencyEventsPanel',
    'CadenceFlagQueue',
    'adminEmployeeList',
    'forceLogin',
    'mergeEmployee',
    'employeeMergerForm',
    'employerMergerForm'
];
export const clientAdminRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    'JobList',
    'jobDetails',
    'reviewDeletedJob',
    'EmployeeList',
    'EmployeeDetails',
    'addEmployee',
    'editEmployee',
    'employerDetails',
    'deleteEmployee',
    'EmployerList',
    'addEmployer',
    'editEmployer',
    'editEmployerClient',
    'PayrollSheet',
    'PayrollJobWorkbook',
    'employerDetails',
    'deleteEmployers',
    'vacationLog',
    'Skills',
    'archiveSkills',
    'rateTable',
    'Notify',
    'DailySchedule',
    'PhoneSheet',
    'Files',
    'bulkAssignCustom',
    'singleAssignCustom',
    'ViewCalls',
    'jobAttendance',
    'addCall',
    'Schedule',
    'scheduleWishlist',
    'scheduleSmslog',
    'actionLog',
    'signinsheet',
    'jobSheet',
    'myProfile',
    'stripeSuccess',
    "authNylas",
    'venueMain',
    'addVenue',
    'reportMain',
    'reportList',
    'jobReports',
    'wishlistAssign',
    'configurationMain',
    'calendar',
    'calendarJobCall',
    'addEmployeeCSV',
    'viewCallsEmployer',
    'addEmployerClient',
    'switchClient',
    'clientEmployeeAssociation',
    'addEmployeeNewFlow',
    'forceLogin',
    'Resume',
    'new-report-list',
    "reports-app-smith",
    'reports-landing',
    'monthly-jobs-report',
    'employee-export-report',
    'employer-export-report',
    'employer-shift-count-report',
    'last-confirmed-shift-report',
    'user-total-hours-report',
    'action-log-search-report',
    'attendance-report',
    'call-user-skill-hours-report',
    'failed-sms-report',
    'nlrb-report',
    'notice-log-search-report',
    'unsubscribed-email-report',
    'monthly-jobs-chart-report',
    'attendance-chart-report',
    'employeeMergerForm',
    'CallList',
    'clientSMSLog',
    'CsInvoices',
    'Employee911Availability',
    'Drive',
    'SplashPage',
    'PrivacyPolicyEditor',
    'PrivacyPolicyReview',
    // #1676 — admin-tier roles (client-admin / power-user / power-user-minus /
    // auditor all check THIS array) reach onboarding from the Onboard tab
    // (/onboarding/send) and the profiles screen (/onboarding/profiles). #1481
    // added 'onboarding-send' to userRoute for granted stewards but never here,
    // so a power-user (e.g. Brandon Healy on ia76) who configured onboarding got
    // bounced to /jobList on every onboarding click. Same allowlist mechanism,
    // same fix — admins configure onboarding (configurationMain is here), so the
    // onboarding tab itself must be reachable too.
    'onboarding-send',
    'onboarding-profiles',
];
export const userRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    'JobList',
    'jobDetails',
    'editEmployee',
    'Notify',
    'PhoneSheet',
    'bulkAssignCustom',
    'singleAssignCustom',
    'ViewCalls',
    'jobAttendance',
    'addCall',
    'Schedule',
    'scheduleWishlist',
    'scheduleSmslog',
    'actionLog',
    'signinsheet',
    'jobSheet',
    'myProfile',
    'stripeSuccess',
    'authNylas',
    'vacationLog',
    'reportMain',
    'reportList',
    'jobReports',
    'wishlistAssign',
    'calendar',
    'calendarJobCall',
    'switchClient',
    'forceLogin',
    'Resume',
    'new-report-list',
    'reports-app-smith',
    'reports-landing',
    'monthly-jobs-report',
    'employee-export-report',
    'employer-export-report',
    'employer-shift-count-report',
    'last-confirmed-shift-report',
    'user-total-hours-report',
    'action-log-search-report',
    'attendance-report',
    'call-user-skill-hours-report',
    'failed-sms-report',
    'nlrb-report',
    'notice-log-search-report',
    'unsubscribed-email-report',
    'monthly-jobs-chart-report',
    'attendance-chart-report',
    // 'CallList',
    // 'CsInvoices'
    'Drive',
    'SplashPage',
    'PrivacyPolicyReview',
    // #1481 — stewards granted onboarding template access reach the send-link
    // page from the Onboard menu item. The route carries no per-route guard;
    // this allowlist is what the global employee guard checks, so without it a
    // granted steward sees the menu but gets bounced back to /schedule.
    'onboarding-send',
    // #1697 — /payroll bounced to /schedule for power users (ed, on stage).
    //
    // NOT a missing route: PayrollSheet is registered, and it is already in
    // superAdminRoute / clientAdminRoute / employerAdminRoute. The guard in
    // main.js switches on the `csLogin` COOKIE, and switchClient.vue:280
    // overwrites that cookie with the user's PER-TENANT effective role slug
    // (`client_details.role.slug`) — not their top-level role. So a power user
    // (or a client admin, #1533 — same branch, same allowlist) working inside a
    // tenant where their own Employee row is a plain employee arrives at
    // `case 'employee'`, which checks THIS array. sideNav.vue meanwhile shows
    // the Payroll item off `userRoleSlug`, so the menu appeared and the click
    // bounced. Exactly the trap the #1676 note above and the #1481 note here
    // both warn about.
    //
    // Listing it here is a client-side UX gate only, and does not widen access:
    // sideNav still hides Payroll from a genuine employee, and
    // PayrollController@sheet / @sheetEmployers refuse anyone who is not
    // PU / CA / EA / SA with a 403 and an empty result. A real employee who
    // typed the URL gets an empty picker and an error, never payroll data.
    'PayrollSheet',
    'PayrollJobWorkbook',
];
export const employerAdminRoute = [
    'addCall',
    'employerJobList',
    'venueMain',
    'empoyerProfile',
    'companyInfo',
    'employerUserList',
    'addEmployerUser',
    'editEmployerUser',
    'editEmployerClient',
    'PayrollSheet',
    'PayrollJobWorkbook',
    'employerJobDetails',
    'viewCallsEmployer',
    'calendarEmployer',
    'calendarJobCall',
    'employerSignInSheet',
    'forceLogin',
];
export const employerRoute = [
    'addCall',
    'employerJobList',
    'venueMain',
    'empoyerProfile',
    'companyInfo',
    'editEmployerUser',
    'employerJobDetails',
    'viewCallsEmployer',
    'calendarEmployer',
    'calendarJobCall',
    'employerSignInSheet',
    'forceLogin'
];
export const employerSheetOnlyRoute = [
    'employerJobList',
    'venueMain',
    'empoyerProfile',
    'companyInfo',
    'employerJobDetails',
    'viewCallsEmployer',
    'calendarEmployer',
    'calendarJobCall',
    'employerSignInSheet',
    'forceLogin'
];
export const publicRoutes = [
    'LoginPage',
    'signInWithGoogle',
    'forceLogin',
    'pageNotFound',
    'resetPassword',
    'jobReports',
    'wishlistAssign',
    'maintenance',
    'magicLink',
    'PrivacyPolicyReview',
    'employeeWindow',
    'onboardForm',
    'onboardFormCode',
    'onboardVerify',
    'wishlistConfirm'
];

export const routes = [
    // Login
    {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage
    },
    {
        path: '/sign-in-with-google',
        name: 'signInWithGoogle',
        component: signInWithGoogle
    },
    // {
    //     path: '/login',
    //     name: 'LoginPage',
    //     component: maintenance
    // },
    {
        path: '/login/:type/:id/:token',
        name: 'forceLogin',
        component: forceLogin
    },
    {
        path: '/switchClient',
        name: 'switchClient',
        component: switchClient
    },
    // pageNotFound
    {
        path: '/pageNotFound',
        name: 'pageNotFound',
        component: pageNotFound
    },
    // Reset Password
    {
        path: '/resetPassword/:id',
        name: 'resetPassword',
        component: resetPassword
    },
    {
        // #1459 one-form: the cs3.me link / QR lands here. `code` is the
        // profile short_code; the form collects phone + details itself.
        path: '/onboard/c/:code',
        name: 'onboardFormCode',
        component: onboardForm
    },
    {
        // #1459 email-verify landing — clicking the emailed link promotes
        // the stub worker to a dispatchable 'basic' worker.
        path: '/onboard/verify/:vtoken',
        name: 'onboardVerify',
        component: onboardForm
    },
    {
        // Public PWA onboarding form. Token is the per-stub-worker
        // identifier baked into a per-worker SMS link.
        path: '/onboard/:token',
        name: 'onboardForm',
        component: onboardForm
    },
    {
        // Public confirm page for the "Notify Wishlist" shortlink (#1151).
        path: '/wishlist-notify/:token',
        name: 'wishlistConfirm',
        component: wishlistConfirm
    },
    {
        path: '/magic-link',
        name: 'magicLink',
        component: magicLink
    },
    // Job List
    {
        path: '/jobList',
        name: 'JobList',
        component: JobList,
        meta: { title: 'Jobs/Events' } 
    },
    // Call List
    {
        path: '/callList11',
        name: 'CallList',
        component: CallList,
    },
    // reviewDeletedJob
    {
        path: '/review-job/:jobId',
        name: 'reviewDeletedJob',
        component: reviewDeletedJob,
    },
    // Job Details
    {
        path: '/jobDetails/:id',
        name: 'jobDetails',
        component: jobDetails,
    },
    // Resume
    {
        path: '/resume',
        name: 'Resume',
        component: Resume
    },
    // Employees
    {
        path: '/employees',
        name: 'EmployeeList',
        component: EmployeeList
    },
    {
        path: '/employeeDetails/:employeeId',
        name: 'EmployeeDetails',
        component: EmployeeDetails
    },
    {
        path: '/addEmployee',
        name: 'addEmployee',
        component: addEmployee
    },
    {
        path: '/editEmployee/:empId',
        name: 'editEmployee',
        component: editEmployee
    },
    {
        path: '/deleteEmployee',
        name: 'deleteEmployee',
        component: deleteEmployee
    },
    {
        path: '/vacationLog/:empId',
        name: 'vacationLog',
        component: vacationLog
    },
    {
        path: '/clientEmployeeAssociation',
        name: 'clientEmployeeAssociation',
        component: clientEmployeeAssociation
    },
    {
        path: '/add-new-employee',
        name: 'addEmployeeNewFlow',
        component: addEmployeeNewFlow
    },
    // Emplyers
    {
        path: '/employerList',
        name: 'EmployerList',
        component: EmployerList

    },
    {
        // #1744 payroll template workspace — Super Admin only. Entry point is the
        // header of /#/clientList. The name below MUST also appear in
        // superAdminRoute or main.js's guard bounces the SA off it (see there).
        path: '/payrollTemplateWorkspace',
        name: 'PayrollTemplateWorkspace',
        component: PayrollTemplateWorkspace
    },
    {
        // #1697 payroll FlexSheet. The param stays OPTIONAL because the sideNav
        // entry links to bare /payroll; an employer is nonetheless REQUIRED to
        // load a period — the page picks one in-page and reflects it back into
        // the URL, rather than rendering a sheet with no employer behind it.
        path: '/payroll/:employerId?',
        name: 'PayrollSheet',
        component: PayrollSheet
    },
    {
        // #1763 — the LOADER screen. Opened in a NEW TAB from the job page, so
        // the job stays put behind it. jobId is base64, as elsewhere in the SPA.
        path: '/payrollWorkbook/:jobId',
        name: 'PayrollJobWorkbook',
        component: PayrollJobWorkbook
    },
    {
        path: '/addEmployer',
        name: 'addEmployer',
        component: addEmployer
    },
    {
        path: '/editEmployer',
        name: 'editEmployer',
        component: editEmployer
    },
    {
        path: '/employerDetails/:employerId',
        name: 'employerDetails',
        component: employerDetails
    },
    {
        path: '/deleteEmployers',
        name: 'deleteEmployers',
        component: deleteEmployers
    },
    // Skills
    {
        path: '/skills',
        name: 'Skills',
        component: Skills
    },
    {
        path: '/archiveSkills',
        name: 'archiveSkills',
        component: archiveSkills
    },
    {
        path: '/rateTable',
        name: 'rateTable',
        component: rateTable
    },
    // Notify
    {
        path: '/notify',
        name: 'Notify',
        component: Notify
    },
    // cs-invoices
    {
        path: '/cs-invoices',
        name: 'CsInvoices',
        component: CsInvoices
    },
    {
        path: '/911-availability',
        name: 'Employee911Availability',
        component: Employee911Availability
    },
    // Splash Page (login page message editor)
    {
        path: '/splash-page',
        name: 'SplashPage',
        component: SplashPage
    },
    // Privacy Policy Editor (client-admin / power-user)
    {
        path: '/privacy-policy-editor',
        name: 'PrivacyPolicyEditor',
        component: PrivacyPolicyEditor
    },
    // Privacy Policy Interstitial (shown after login)
    {
        path: '/privacy-policy-review',
        name: 'PrivacyPolicyReview',
        component: PrivacyPolicyReview
    },
    // Daily Schedule
    {
        path: '/dailySchedule',
        name: 'DailySchedule',
        component: DailySchedule
    },
    // Phonesheet
    {
        path: '/phoneSheet/:jobId',
        name: 'PhoneSheet',
        component: PhoneSheet
    },
    // Files
    {
        path: '/files',
        name: 'Files',
        component: Files
    },
    // Drive
    {
        path: '/drive',
        name: 'Drive',
        component: Drive
    },
    // Calls
    {
        path: '/bulkAssignCustom/:id',
        name: 'bulkAssignCustom',
        component: bulkAssignCustom
    },
    {
        path: '/singleAssignCustom/:id',
        name: 'singleAssignCustom',
        component: singleAssignCustom
    },  
    // View Calls
    {
        path: '/viewCalls/:jobId',
        name: 'ViewCalls',
        component: ViewCalls
    },
    {
        path: '/addCall/:id',
        name: 'addCall',
        component: addCall
    },
    // 'jobAttendance',
    {
        path: '/jobAttendance/:jobId',
        name: 'jobAttendance',
        component: jobAttendance
    },
    // Schedule
    {
        path: '/schedule/:empId',
        name: 'Schedule',
        component: Schedule,
    },
    {
        path: '/wishlist/:empId',
        name: 'scheduleWishlist',
        component: scheduleWishlist,
    },
    {
        path: '/notifyLog/:empId',
        name: 'scheduleSmslog',
        component: scheduleSmslog,
    },
    {
        path: '/clientSmsLog',
        name: 'clientSMSLog',
        component: clientSMSLog,
    },
    {
        path: '/actionlog/:empId',
        name: 'actionLog',
        component: actionLog,
    },
    //Sign in Sheet
    {
        path: '/signinsheet/:jobId',
        name: 'signinsheet',
        component: signinsheet,
    },
    {
        path: '/jobSheet/:id',
        name: 'jobSheet',
        component: jobSheet,
    },

    // Profile
    {
        path: '/myProfile',
        name: 'myProfile',
        component: myProfile
    },
    {
        path: '/stripe-success',
        name: 'stripeSuccess',
        component: stripeSuccess
    },
    // auth Nylas
    {
        path: '/authNylas',
        name: 'authNylas',
        component: authNylas
    },
    // Venue

    {
        path: '/venue',
        name: 'venueMain',
        component: venueMain
    },
    {
        path: '/addVenue',
        name: 'addVenue',
        component: addVenue
    },
    // Report
    {
        path: '/report/:id',
        name: 'reportMain',
        component: reportMain
    },
    // Report List
    {
        path: '/reportList',
        name: 'reportList',
        component: reportList
    },
    {
        path: '/new-report-list',
        name: 'new-report-list',
        component: newReportGlobal
    },
    {
        path: '/report-list',
        name: 'reports-landing',
        component: ReportsLanding
    },
    {
        path: '/onboarding/profiles',
        name: 'onboarding-profiles',
        component: OnboardingProfiles,
    },
    {
        path: '/onboarding/send',
        name: 'onboarding-send',
        component: SendOnboardingLink,
    },
    {
        path: '/report-list/appsmith',
        name: 'reports-app-smith',
        component: reportsAppSmith
    },
    {
        path: '/reports/monthly-jobs',
        name: 'monthly-jobs-report',
        component: MonthlyJobReport,
    },
    {
        path: '/reports/employee-export',
        name: 'employee-export-report',
        component: EmployeeExportReport,
    },
    {
        path: '/reports/employer-export',
        name: 'employer-export-report',
        component: EmployerExportReport,
    },
    {
        path: '/reports/employer-shift-count',
        name: 'employer-shift-count-report',
        component: EmployerShiftCountReport,
    },
    {
        path: '/reports/last-confirmed-shift',
        name: 'last-confirmed-shift-report',
        component: LastConfirmedShiftReport,
    },
    {
        path: '/reports/user-total-hours',
        name: 'user-total-hours-report',
        component: UserTotalHoursReport,
    },
    {
        path: '/reports/action-log-search',
        name: 'action-log-search-report',
        component: ActionLogSearchReport,
    },
    {
        path: '/reports/attendance',
        name: 'attendance-report',
        component: AttendanceReport,
    },
    {
        path: '/reports/call-user-skill-hours',
        name: 'call-user-skill-hours-report',
        component: CallUserSkillHoursReport,
    },
    {
        path: '/reports/failed-sms',
        name: 'failed-sms-report',
        component: FailedSmsReport,
    },
    {
        path: '/reports/nlrb',
        name: 'nlrb-report',
        component: NlrbReport,
    },
    {
        path: '/reports/notice-log-search',
        name: 'notice-log-search-report',
        component: NoticeLogSearchReport,
    },
    {
        path: '/reports/unsubscribed-email',
        name: 'unsubscribed-email-report',
        component: UnsubscribedEmailReport,
    },
    {
        path: '/reports/monthly-jobs-chart',
        name: 'monthly-jobs-chart-report',
        component: MonthlyJobChartReport,
    },
    {
        path: '/reports/attendance-chart',
        name: 'attendance-chart-report',
        component: AttendanceChartReport,
    },
    // ActiveReports viewer (for jobReports)
    {
        path: '/jobReports/:url',
        name: 'jobReports',
        component: activeReports
    },
    // #1533: wishlist-summary assign page (opened from the report's per-row link)
    {
        path: '/wishlist-assign',
        name: 'wishlistAssign',
        component: WishlistAssign
    },
    // Configuration
    {
        path: '/configuration',
        name: 'configurationMain',
        component: configurationMain
    },
    //calendar
    {
        path: '/calendar',
        name: 'calendar',
        component: calendar
    },
    //calendarJobCall
    {
        path: '/calendarJobCall/:jobId',
        name: 'calendarJobCall',
        component: calendarJobCall
    },
    //client list
    {
        path: '/clientList',
        name: 'clientList',
        component: clientList,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //add client
    {
        path: '/addClient',
        name: 'addClient',
        component: addClient,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //edit client
    {
        path: '/editClient',
        name: 'editClient',
        component: editClient,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //Send Notice
    {
        path: '/clientSendNotice',
        name: 'clientSendNotice',
        component: clientSendNotice,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    // Manage Exception
    {
        path: '/manageExceptions',
        name: 'manageExceptions',
        component: manageExceptions,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    // Add Employee CSV
    {
        path: '/addEmployeeCSV',
        name: 'addEmployeeCSV',
        component: addEmployeeCSV,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    {
        path: '/adminConfig',
        name: 'adminConfig',
        component: adminConfig
    },

    {
        path: '/admin-reports-configuration',
        name: 'ReportsConfig',
        component: ReportsConfig
    },

    {
        path: '/sa/traffic/concurrency-events',
        name: 'ConcurrencyEventsPanel',
        component: ConcurrencyEventsPanel
    },
    {
        path: '/sa/traffic/cadence-flags',
        name: 'CadenceFlagQueue',
        component: CadenceFlagQueue
    },

    //client Employers List
    {
        path: '/clientEmployersList',
        name: 'clientEmployersList',
        component: clientEmployersList,
    },
    // Add Employer Client
    {
        path: '/addEmployerClient',
        name: 'addEmployerClient',
        component: addEmployerClient,
    },
    // Edit Employer Client
    {
        path: '/editEmployerClient/:id',
        name: 'editEmployerClient',
        component: editEmployerClient,
    },
    //
    {
        path: '/employerDetailsClient/:id',
        name: 'employerDetailsClient',
        component: employerDetailsClient,
    },
    {
        path: '/employerJobList',
        name: 'employerJobList',
        component: employerJobList,
    },
    {
        path: '/employerSignInSheet/:jobId',
        name: 'employerSignInSheet',
        component: employerSignInSheet,
    },
    {
        path: '/empoyerProfile/:id',
        name: 'empoyerProfile',
        component: empoyerProfile,
    },
    {
        path: '/companyInfo',
        name: 'companyInfo',
        component: companyInfo,
    },
    {
        path: '/employerUserList',
        name: 'employerUserList',
        component: employerUserList,
    },
    {
        path: '/addEmployerUser',
        name: 'addEmployerUser',
        component: addEmployerUser,
    },
    {
        path: '/editEmployerUser/:id',
        name: 'editEmployerUser',
        component: editEmployerUser,
    },
    {
        path: '/employerJobDetails/:id',
        name: 'employerJobDetails',
        component: employerJobDetails,
    },
    {
        path: '/viewCallsEmployer/:jobId',
        name: 'viewCallsEmployer',
        component: viewCallsEmployer,
    },
    {
        path: '/calendarEmployer',
        name: 'calendarEmployer',
        component: calendarEmployer,
    },
    {
        path: '/tinyUrl',
        name: 'tinyUrl',
        component: tinyUrl,
    },
    {
        path: '/adminEmployeeList',
        name: 'adminEmployeeList',
        component: superAdminEmployeeList,
    },
    {
        path: '/mergeEmployee',
        name: 'mergeEmployee',
        component: mergeEmployee,
    },
    {
        path: '/employeeMergerForm',
        name: 'employeeMergerForm',
        component: employeeMergerForm,
    },
    {
        path: '/employerMergerForm',
        name: 'employerMergerForm',
        component: employerMergerForm,
    },
    // Open Window — employee self-dispatch page
    {
        path: '/window/:token',
        name: 'employeeWindow',
        component: EmployeeWindow,
    },
];
